import React from "react";
import ElectricityIcon from "@enerex/unified-ui-react/icons/ElectricityIcon";
import GasIcon from "@enerex/unified-ui-react/icons/GasIcon";

export const CommodityIcon = ({ type }) => {
  const isElectric = type === "electric";
  const Icon = isElectric ? ElectricityIcon : GasIcon;
  return (
    <span
      className={`d-inline-flex align-items-center justify-content-center lh-1 ${isElectric ? "text-warning" : "text-success"}`}
      title={isElectric ? "Electric" : "Natural Gas"}
    >
      <Icon />
    </span>
  );
};

export const CommodityBadges = ({ commodityId }) => {
  const id = Number(commodityId);
  return (
    <span className="d-inline-flex align-items-center gap-1">
      {(id === 1 || id === 5 || id === 3) && <CommodityIcon type="electric" />}
      {(id === 2 || id === 5 || id === 3) && <CommodityIcon type="gas" />}
      {!(id === 1 || id === 2 || id === 3 || id === 5) && <span className="text-muted">-</span>}
    </span>
  );
};

export const StateCommodityBadge = ({ state }) => (
  <span className="badge bg-light text-dark border d-inline-flex align-items-center gap-1 fw-normal">
    <span>{state.stateName || state.StateName}</span>
    <CommodityBadges commodityId={state.commodityId || state.CommodityId} />
  </span>
);
